import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getOfferData, getOfferList } from "./OfferApi";
import { OfferDataState } from "../../../features/view/public/offerListing/offerListingTypes";

const initialState: OfferDataState = {
  offerList: { data: [], loader: false },
  offerData: { data: {}, loader: false },
};

export const getOfferListAsync = createAsyncThunk(
  "/orders/discounts/",
  async () => {
    const response = await getOfferList();
    return response;
  }
);

export const getOfferDataAsync = createAsyncThunk(
  "orders/discounts",
  async (id: any) => {
    const response = await getOfferData(id);
    return response;
  }
);

export const OfferSlice = createSlice({
  name: "offer",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getOfferListAsync.pending, (state) => {
        state.offerList.loader = true;
      })
      .addCase(getOfferListAsync.fulfilled, (state, action: any) => {
        state.offerList.loader = false;
        state.offerList.data = action?.payload?.data || [];
      })
      .addCase(getOfferListAsync.rejected, (state) => {
        state.offerList.loader = false;
      })
      .addCase(getOfferDataAsync.pending, (state) => {
        state.offerData.loader = true;
      })
      .addCase(getOfferDataAsync.fulfilled, (state, action: any) => {
        state.offerData.loader = false;
        // state.offerData.data = action?.payload?.data || [];
        const data = action?.payload?.data?.data || [];
        const filteredProducts = data?.map((item: any) => {
          return {
            ...item,
            products: item?.products?.filter((product: any) => {
              // Check if there is at least one SKU with status "Visible"
              return product?.skus?.some(
                (sku: { sku_status: string }) => sku?.sku_status === "Visible"
              );
            }),
          };
        });
        console.log("filtere : ", filteredProducts);
        state.offerData.data = filteredProducts || [];
      })
      .addCase(getOfferDataAsync.rejected, (state) => {
        state.offerData.loader = false;
      });
  },
});

export default OfferSlice.reducer;
